module.exports = __webpack_public_path__ + "static/media/cockpit.148caa28.ttf";